/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface SaveLicenseFeatureAccessModules$Request {
    licenseId: number;
    requestBody: Array<string>;
}

export interface SaveLicenseFeatureAccessModules$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveLicenseFeatureAccessModulesRequest = createAction<PayloadData<void, SaveLicenseFeatureAccessModules$Request>>('SAVE_LICENSE_FEATURE_ACCESS_MODULES__SAVE_LICENSE_FEATURE_ACCESS_MODULES__REQUEST');
export const saveLicenseFeatureAccessModulesSuccess = createAction<PayloadData<void, SaveLicenseFeatureAccessModules$Request>>('SAVE_LICENSE_FEATURE_ACCESS_MODULES__SAVE_LICENSE_FEATURE_ACCESS_MODULES__SUCCESS');
export const saveLicenseFeatureAccessModulesFailure = createAction<PayloadData<Error, SaveLicenseFeatureAccessModules$Request, true>>('SAVE_LICENSE_FEATURE_ACCESS_MODULES__SAVE_LICENSE_FEATURE_ACCESS_MODULES__FAILURE');

export const saveLicenseFeatureAccessModulesActions = [
    saveLicenseFeatureAccessModulesRequest,
    saveLicenseFeatureAccessModulesSuccess,
    saveLicenseFeatureAccessModulesFailure
] as const;

/**
 * @param {number} meta.licenseId
 * @param {Array<string>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveLicenseFeatureAccessModules = (meta: SaveLicenseFeatureAccessModules$Request, config?: SaveLicenseFeatureAccessModules$Config) => {
    return {
        CALL_API: {
            types: saveLicenseFeatureAccessModulesActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/licenses/${meta.licenseId}/feature-access-module`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

